var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "m-miniTabs" },
    _vm._l(_vm.tabs, function(item) {
      return _c(
        "li",
        {
          key: item.vule,
          class: { "z-active": _vm.isActive(item) },
          on: {
            click: function($event) {
              _vm.setCurrent(item)
            }
          }
        },
        [_vm._v(_vm._s(item.name))]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51d4819d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d4819d","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mini_tabs/mini_tabs.vue
// module id = 315
// module chunks = 3